import { ProcessCellForExportParams } from 'ag-grid-community';
import {
  processCellFromClipboardWithShowError,
  useSimpleFormatMessage,
} from 'components/secondaryMarket/shared/Clipboard/clipboard';
import { translateEliotCodeIntoSaleCounterpart } from 'components/secondaryMarket/shared/Clipboard/parse-eliot-code';
import { AsyncTranslators } from 'components/secondaryMarket/shared/Clipboard/types';
import { EditableFieldInfo } from 'components/shared/Blotter/Grid/blotter.model';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { SecondaryMarketProduct } from 'state/secondaryMarket/productSearch';
import { secondaryMarketProductsValueChangedSetEditableInfo } from 'state/secondaryMarket/productSearch/productSearch.actions';

const asyncTranslators: AsyncTranslators<SecondaryMarketProduct, 'client' | 'custodian'> = {
  client: translateEliotCodeIntoSaleCounterpart,
  custodian: translateEliotCodeIntoSaleCounterpart,
};

export const processCellForClipboard = (params: ProcessCellForExportParams<SecondaryMarketProduct>) => {
  const colId = params.column?.getColId() as keyof SecondaryMarketProduct;
  if (colId === 'client' || colId === 'custodian') {
    return params.value.eliotCode;
  }
  return params.value;
};

export function useProcessCellFromClipboard(getRowId: (row: SecondaryMarketProduct) => string) {
  const dispatch = useDispatch();
  const simpleFormatMessage = useSimpleFormatMessage();
  const result = useMemo(() => {
    const setUserFeedbackWithCell =
      ({ rowId, field }: { rowId: string; field: keyof SecondaryMarketProduct }) =>
      (state: EditableFieldInfo) => {
        dispatch(secondaryMarketProductsValueChangedSetEditableInfo(rowId, field, state));
      };

    return processCellFromClipboardWithShowError<SecondaryMarketProduct, never, 'client' | 'custodian'>({
      asyncTranslators,
      syncTranslators: {},
      getRowId,
      simpleFormatMessage,
      setUserFeedbackWithCell,
    });
  }, [dispatch, getRowId, simpleFormatMessage]);
  return result;
}
